// Triggers a download of the supplied blob with the given filename.
// CSP-safe: uses a temporary anchor + blob URL revoked after the click tick.
export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  try {
    a.click();
  } finally {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.remove();
    }, 0);
  }
}

export function defaultScreenshotFilename(modelFilename: string, ext: string = 'png'): string {
  const base = modelFilename.replace(/\.[^/.]+$/, '');
  const stamp = new Date().toISOString().replace(/[:.]/g, '-');
  return `${base}_${stamp}.${ext}`;
}
